<template>
    <div class="abnormal">
        <form-screen
            :form-data="formData"
            @formChange="getSonCompanyList"
            @confirm="formConfirm"
            @resetSonCompany="resetSonCompany"
        />
        <el-table :data="listTable" border style="width: 100%" :header-cell-style="{ textAlign: 'center' }" v-loading="loadingTable">
            <el-table-column prop="purchaseNumber" label="采购单号" width="200" align="center"></el-table-column>
            <el-table-column prop="orderId" label="订单号" width="240" align="left">
                <template slot-scope="scope">
                    <div v-if="scope.row.purchaseFrom !== 2">
                        <div>订单号：{{ scope.row.amazonOrderId }}</div>
                        <div>订单ID：{{ scope.row.orderId }}</div>
                    </div>
                    <div v-else>
                        <div>库存编号：{{ scope.row.inventoryNo }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="purchaseModel" label="核对详情" width="120" align="center"></el-table-column>
            <el-table-column prop="internalConveyNumber" label="国内单号" width="200" align="center"></el-table-column>
<!--            <el-table-column prop="purchaseSize" label="尺寸" width="100" align="center"></el-table-column>-->
<!--            <el-table-column prop="purchaseWeight" label="重量" width="100" align="center"></el-table-column>-->
<!--            <el-table-column prop="purchaseTypeCode" label="货物类型" width="100" align="center"></el-table-column>-->
<!--            <el-table-column prop="purchaseClass" label="货物等级" align="center" width="80"></el-table-column>-->
            <el-table-column prop="" label="异常信息" align="left" width="300px">
              <template slot-scope="scope">
                  <div v-if="scope.row.exceptionImages!==null">
                  <el-row type="flex">
                    <el-popover trigger="hover" placement="bottom-start">
                      <img :src="scope.row.exceptionImages[0]" alt  style="width:200px;height:200px;"/>
                      <div class="scope_img" slot="reference">
                        <img :src="scope.row.exceptionImages[0]" alt style="width:50px;height:50px;margin-left:10px;"/>
                      </div>
                    </el-popover>
                    <div style="margin-left:10px;">
                      <p>{{ scope.row.exceptionRemark }}</p>
                    </div>
                  </el-row>
                  </div>
              </template>
            </el-table-column>
          <el-table-column prop="handleDescription" label="处理方案" width="200" align="center"></el-table-column>
          <el-table-column prop="exceptionResult" label="状态" width="140" align="center">
                <template slot-scope="scope">
                    <div style="color: red;" v-if="scope.row.exceptionResult === 0">未处理</div>
                    <div style="color:blue;" v-else-if="scope.row.exceptionResult === 1">申请退件</div>
                    <div style="color:green;" v-else-if="scope.row.exceptionResult === 2">确认退件</div>
                    <div style="color:blue;" v-else-if="scope.row.exceptionResult === 3">申请转库存</div>
                    <div style="color:green;" v-else-if="scope.row.exceptionResult === 4">确认转库存</div>
                    <div style="color:blue;" v-else-if="scope.row.exceptionResult === 5">申请取消异常</div>
                    <div style="color:green;" v-else-if="scope.row.exceptionResult === 6">确认取消异常</div>
                    <div style="color:blue;" v-else-if="scope.row.exceptionResult === 9">申请转未知</div>
                    <div style="color:green;" v-else-if="scope.row.exceptionResult === 10">确认转未知</div>
                </template>
            </el-table-column>
<!--            <el-table-column label="核对结果" align="center" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <div style="color: #0565b7;" v-if="scope.row.checkResult === 0">未核对</div>-->
<!--                    <div style="color: green;" v-else-if="scope.row.checkResult === 1">核对正确</div>-->
<!--                    <div style="color: red;" v-else-if="scope.row.checkResult === 2">核对错误</div>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="putStorageTime" label="入库时间" width="200" align="center"></el-table-column>
            <el-table-column prop="updateTime" label="更新时间" width="200" align="center"></el-table-column>
          <!-- <el-table-column prop="branchCompanyName" label="所属分公司" width="200" align="center"></el-table-column>
          <el-table-column prop="subCompanyName" label="所属子公司" width="200" align="center"></el-table-column> -->
            <el-table-column width="200" prop="ziName" label="所属公司" align="center">
                <template slot-scope="scope">
                    <div>
                        <span>{{ scope.row.branchCompanyName }}</span>
                        <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
                        <span>{{ scope.row.subCompanyName }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="80" align="center">
                <template slot-scope="scope">
                    <i class="el-icon-edit-outline fontSize-30" @click="edit(scope.row)"></i>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20, 50, 100, 200, 300]"
                :page-size="size"
                layout="total, sizes,prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </div>

        <!-- 信息核对 -->
        <Abnormaldetails ref="Abnormaldetails" :user-info="UserInfo" @confirm="AbnormaldetailsConfirm" />
    </div>
</template>

<script>
import formScreen from "./abnormaldetails/formScreen";
import Abnormaldetails from "./abnormaldetails/abnormaldetails";

import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
    name: "abnormal",
    components: {
        formScreen,
        Abnormaldetails,
    },
    data() {
        return {
            formData: {
                listBranch: [],
                listSon: [],
                listChannel: [],
            },
            formScreenData: {},
            listTable: [],
            page: 1,
            size: 20,
            total: 0,
            UserInfo: {},
            loadingTable: false
        };
    },
    created() {
        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        this.getTableData();
        this.getBranchCompanyList();
    },
    methods: {
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.page = val;
            this.getTableData();
        },
        edit(row) {
            this.$refs.Abnormaldetails.init(row);
        },
        AbnormaldetailsConfirm(dataOut) {
            const API = Baseurl + "logisticsController/updatePurchaseExceptionResult";
            const paramsData = {
                roleId: this.UserInfo.rid,
                companyId: this.UserInfo.company_id,
                ...dataOut,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    // const handelClose = () => {
                        this.$refs.Abnormaldetails.close();
                        this.getTableData();
                        this.$message.success("操作成功");
                    // }
                    // if (dataOut.exceptionResult === '5') {
                    //     handelClose()
                    // } else {
                    // let tips = '是否增加一条采购单?'
                    // if (dataOut.exceptionResult === '3') {
                    //     tips = '确认转库存之后，是否增加一条采购单'

                    //     this.$confirm(tips, '提示', {
                    //     closeOnClickModal: false
                    //     }).then(() => {
                    //         this.$refs.Abnormaldetails.initFourth();
                    //     }).catch(() => {
                    //         this.$confirm('取消之后，将无法添加采购单，是否取消', '提示', {
                    //             closeOnClickModal: false
                    //         }).then(() => {
                    //             handelClose()
                    //         }).catch(() => {
                    //             this.$refs.Abnormaldetails.initFourth();
                    //         })
                    //     })
                    // } else if (dataOut.exceptionResult === '1') {
                    //     tips = '确认退件之后，是否增加一条采购单'
                        
                    //     this.$confirm(tips, '提示', {
                    //         closeOnClickModal: false
                    //     }).then(() => {
                    //         this.$refs.Abnormaldetails.initFourth();
                    //     }).catch(() => {
                    //         this.$confirm('取消之后，将无法添加采购单，是否取消', '提示', {
                    //             closeOnClickModal: false
                    //         }).then(() => {
                    //             handelClose()
                    //         }).catch(() => {
                    //             this.$refs.Abnormaldetails.initFourth();
                    //         })
                    //     })
                    // }
                    
                    // }
                } else {
                    this.$message.error(data || '操作失败');
                }
            });
        },
        getTableData() {
            const API = Baseurl + "logisticsController/getInventoryPurchaseList";
            const paramsData = {
                ...this.formScreenData,
                roleId: this.UserInfo.rid,
                page: this.page,
                size: this.size,
                listType: "3",
                superDepartmentName: this.UserInfo.superDepartmentName,
                companyId: this.UserInfo.company_id,
            };
            this.loadingTable = true
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.loadingTable = false
                    this.listTable = data.list;
                    this.total = data.total;
                }
            });
        },
        formConfirm(data) {
            this.formScreenData = data;
            this.page = 1
            this.getTableData();
        },
        resetSonCompany() {
            this.page = 1
            this.formData.listSon = [];
        },
        getBranchCompanyList() {
            const API = Baseurl + "logisticsController/getAllBranchCompany";
            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.formData.listBranch = data;
                }
            });
        },
        getSonCompanyList(id) {
            const API = Baseurl + "logisticsController/getAllSubCompanyById";
            const paramsData = { id };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.formData.listSon = data;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.abnormal {
    padding-bottom: 72px;
    .header-button-box {
        margin: 10px 0;
    }
    .custom-out-form {
        .el-form-item {
            margin: 0;
        }
    }
    .pagination-container {
        width: 1660px;
        padding: 20px;
        position: fixed;
        right: 0;
        bottom: 0;
        background: #fff;
        z-index: 999;
        .el-pagination {
            display: flex;
            justify-content: center;
        }
    }
}
</style>
